import ModalDialog from '@ui/modal/ModalDialog';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
const BagItem = (props) => {
    var _a, _b, _c;
    const { t } = useTranslation();
    const [show, setShow] = useState(true);
    let contentLabel = '';
    let alertText = '';
    let newItemsCount = (_a = props.bag) === null || _a === void 0 ? void 0 : _a.exchangeModel.items.filter((item) => item.exchangeType === 'new-item').length;
    let sizeColorCount = (_b = props.bag) === null || _b === void 0 ? void 0 : _b.exchangeModel.items.filter((item) => item.exchangeType === 'size-color-type').length;
    let sameItemCount = (_c = props.bag) === null || _c === void 0 ? void 0 : _c.exchangeModel.items.filter((item) => item.exchangeType === 'same-item').length;
    if (!show) {
        return React.createElement(React.Fragment, null);
    }
    if (sizeColorCount >= 1 && !newItemsCount) {
        contentLabel = t('exchanges.choosenewsize');
        alertText = t('exchanges.colorsize.alerttext');
    }
    if (newItemsCount >= 1) {
        contentLabel = t('exchanges.chooseanewitem');
        alertText = t('exchanges.alerttext');
    }
    if (sameItemCount >= 1) {
        contentLabel = t('exchanges.sameitem');
        alertText = t('exchanges.sameitemtext');
    }
    return (React.createElement(ModalDialog, { className: "info-modal exchange-modal modal--fixed-small", overlayClassName: "mobile-visible", isOpen: true, contentLabel: contentLabel, onRequestClose: () => setShow(false) },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "info-modal__description" },
                alertText,
                " "),
            React.createElement("div", { className: "info-modal__columns" },
                React.createElement("div", { className: "info-modal__single-column title" },
                    React.createElement("span", null, t('exchanges.exchangeamount'))),
                React.createElement("div", { className: "info-modal__single-column text-right" },
                    React.createElement("span", null, props.bag.exchangeModel.moneyAmount))))));
};
export default BagItem;
